var path = 'src/app/forms/error.html';
var html = "<span ng-if=showError() class=help-block ng-transclude></span> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/forms/error.html
 ** module id = 321
 ** module chunks = 0
 **/